<template>
	<div class="plugins-external-card">

		<AppCard class="card-margin" :title="getString('marketplace_list')">
			<template v-slot:body>
				<div class="blur-container" v-if="!hasOrderPay" @click="notifyMissingOrderPaySubscription"></div>
				<AppList :items="pluginsActive">
					<template v-slot:plugin-heading="{item, index}">
						<div @click="clickItem(index)" class="row centered plugin-heading" :ref="'plugin-'+index">
							<div class="plugin-heading-icon">
								<div class="plugin-icon-container" :style="'--color-start:'+(item.color ? '#'+item.color : '--color-primary' )+';--color-end:'+(item.color ? '#'+item.color : '--color-primary' )+';'">
									<img v-if="item.icon" :src="item.icon" alt="">
									<div v-else v-html="getIcon('iconPlugins')"></div>
								</div>
							</div>
							<div class="plugin-heading-text">
								<h3>{{ item.title }}</h3>
								<p><span v-if="!!item.business_id" class="private-tag">{{ getString('private') }}</span>{{ getString(item.description) }}</p>
							</div>
							<div class="plugin-heading-status">
								<div class="open-container">
									<div class="plugin-status-container" :class="{active: item.selected}"></div>
									<AppChevronIcon :direction="item.active ? 'up' : 'down'" />
								</div>
							</div>
						</div>
					</template>
					<template v-slot:plugin-dropdown="{item}">
						<div class="row plugin-dropdown">
							<div class="dropdown-left">
								<div class="row centered space-between row-dropdown">
									<p class="dropdown-title">{{ getString('activation_url') }}</p>
									<p class="dropdown-value">{{ item.url_activation }}</p>
								</div>
								<div class="sync-row-container" v-if="item.selected">
									<div class="row row-dropdown line"></div>
									<div class="row centered space-between row-dropdown mt-4">
										<p class="dropdown-title">{{ getString('sync_menu', [this.userStore.menuWord]) }}</p>
										<AppButton outline :text="getString('sync')" @click="pluginSyncId = item.plugin_id" />
									</div>
								</div>
								<div class="logs-row-container" v-if="!!item.business_id">
									<div class="row row-dropdown line"></div>
									<div class="row centered space-between row-dropdown mt-4">
										<p class="dropdown-title">{{ getString('plugin_logs', [this.userStore.menuWord]) }}</p>
										<AppButton outline :text="getString('logs')" @click="pluginLogsId = item.plugin_id" />
									</div>
								</div>
								<div class="row row-dropdown line"></div>
								<div class="row centered space-between row-dropdown mt-4">
									<p class="dropdown-title">External Location ID</p>
									<p class="dropdown-value" v-if="item.selected">{{ item.externalLocationId ? item.externalLocationId : '-' }}</p>
									<AppTextInput v-else :ref="'external-location-id-'+item.plugin_id" placeholder="External Location ID" :class="{disabled: !availablePlugin(item)}" />
								</div>
								<div class="sync-row-container" v-if="!item.selected && item.require_secret">
									<div class="row row-dropdown line"></div>
									<div class="row centered space-between row-dropdown mt-4">
										<p class="dropdown-title">Secret Token</p>
										<AppTextInput :ref="'plugin-secret-'+item.plugin_id" placeholder="Secret token" type="password" :class="{disabled: !availablePlugin(item)}" />
									</div>
								</div>
								<div class="sync-row-container" v-if="isPaidPlugin(item)" :class="{disabled: !availablePlugin(item)}">
									<div class="row row-dropdown line"></div>
									<div class="row centered flex-end row-dropdown mt-4">
										<AppButton @click="togglePlugin(item)" :disabled="!availablePlugin(item)" :outline="item.selected" :loading="loadingSubscription" :text="getString(item.selected ? 'disconnect' : 'connect')" />
									</div>
								</div>
							</div>
							<div class="dropdown-right">
								<p>{{ readablePluginPrice(item) }}</p>
								<small class="fixed-order-fee" v-show="item.order_fixed_fee">{{ readableFixedFee(item) }}</small>
							</div>
						</div>
						<div class="row button-row">
							<AppButton v-if="isPaidPlugin(item) && !availablePlugin(item)" @click="clickEnablePaidPlugin(item)" :loading="loadingSubscription || loadingPaidPlugin" :outline="item.selected" :text="getString('enable')" />
							<AppButton v-if="isPaidPlugin(item) && availablePlugin(item)" @click="disablePaidPlugin(item)" :loading="loadingSubscription || loadingPaidPlugin" outline :text="getString('disable')" />
							<AppButton v-if="!isPaidPlugin(item)" @click="togglePlugin(item)" :loading="loadingSubscription" :outline="item.selected" :text="getString(item.selected ? 'disable' : 'enable')" />
							<AppButton v-if="!item.selected && !!item.business_id && item.business_id === Number(userStore.currBusinessId)" @click="deletePlugin(item)" outline :text="getString('remove')" />
						</div>
					</template>
					<template #new-plugin>
						<div class="new-plugin-container">
							<div class="row centered space-between row-clickable row-clickable-new-plugin" @click="toggleNewItem(null)">
								<img :src="'https://img.qromo.io/img/vue/icons/icon-plus'+(userStore.darkMode ? '-dark' : '')+'.svg'" draggable="false" class="icon-dimension-15 mr-10" alt="icon plus">
								<p class="chevron-p">{{ getString('new_plugin') }}</p>
								<div class="chevron-container">
									<AppChevronIcon :direction="newActive ? 'up' : 'down'" />
								</div>
							</div>
							<AppDropdown :collapsed="!newActive">
								<PluginNew @added-plugin="addedPlugin" />
							</AppDropdown>
						</div>
					</template>
				</AppList>
			</template>
		</AppCard>
		<AppPopup
			:title="getString('credentials')"
			:buttons="buttonsArray"
			ref="popup-credentials">
			<div class="body-info">
				<div class="row centered">
					<p class="text-align-center">{{ getString('credentials_explain') }}</p>
				</div>
				<div class="row space-between mt-8">
					<p class="credential-title">client_id</p>
					<p class="credential-secret">{{ id ? id : '-' }}</p>
				</div>
				<div class="row space-between mt-8">
					<p class="credential-title">client_secret</p>
					<p class="credential-secret">{{ secret ? secret : '-' }}</p>
				</div>
			</div>
		</AppPopup>
		<AppPopup
			:title="getString('delete_plugin')"
			:bodyText="getString('delete_plugin_explain')"
			:buttons="buttonsDeleteArray"
			ref="popup-delete-plugin"
		/>
		<AppPopup :preventOverlayDismiss="loadingOtherPayments" ref="popup-other-payments" :title="getString('enable_other_payments_methods')" :buttons="loadingOtherPayments ? [] : [{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: subOtherPaymentsMethod}]">
			<div v-if="loadingOtherPayments" class="row centered loader-container"><AppLoader primary /></div>
			<p v-if="!loadingOtherPayments" class="popup-body-text">{{ getString('enable_other_payments_methods_plugins_explain') }}</p>
		</AppPopup>
		<AppBottomSheet :force-width="bottomSheetWidth" :active="pluginSyncId !== null" @toggling-popup="togglingPopupPlugin">
			<div class="container-sync-menu" v-if="!!pluginSyncId">
				<PluginSyncMenu :plugin-id="pluginSyncId" @close="pluginSyncId = null" />
			</div>
		</AppBottomSheet>
		<AppBottomSheet :force-width="bottomSheetWideWidth" :active="pluginLogsId !== null" @toggling-popup="togglingPopupPluginLogs">
			<div class="container-logs" v-if="!!pluginLogsId">
				<PluginLogs :plugin-id="pluginLogsId" @close="pluginLogsId = null" />
			</div>
		</AppBottomSheet>
		<CheckoutInPlace :client-secret="clientSecret" @toggling-popup="togglingPopupSheet" @checkout-complete="paymentComplete" />
	</div>
</template>

<script>
import AppCard from "@/shared/components/AppCard.vue";
import AppList from "@/shared/components/AppList.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppPopup from "@/shared/components/AppPopup.vue";

import {useLanguageStore, useSvgStore, useNotificationStore, useCurrencyStore} from "@/shared/stores";
import {useUserStore, usePluginsStore} from "@/console-new/stores";

import WindowWidth from "@/console-new/mixins/WindowWidth";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import PluginNew from "@/console-new/components/plugins/PluginNew.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import PluginSyncMenu from "@/console-new/components/plugins/PluginSyncMenu.vue";
import PluginLogs from "@/console-new/components/plugins/PluginLogs.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import CheckoutInPlace from "@/console-new/components/shared/CheckoutInPlace.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let svgStore = useSvgStore();
		let notificationStore = useNotificationStore();
		let pluginsStore = usePluginsStore();
		const currencyStore = useCurrencyStore();
		return {languageStore, currencyStore, pluginsStore, getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, getIcon: svgStore.get}
	},
	name: "PluginsExternalCard",
	mixins: [WindowWidth],
	components: {
		CheckoutInPlace,
		AppLoader,
		PluginSyncMenu, AppBottomSheet, AppDropdown, AppTextInput, AppList, AppButton, AppPopup, AppChevronIcon, AppCard, PluginNew, PluginLogs},
	data() {
		return {
			loadingSubscription: false,
			loadingPluginDelete: false,
			loadingOtherPayments: false,
			loadingPaidPlugin: false,
			activePlugin: null,
			newActive: false,
			id: null,
			secret: null,
			pluginSyncId: null,
			pluginLogsId: null,
			clientSecret: null,
		}
	},
	computed: {
		otherPaymentsActive() {
			return this.userStore.currBusiness ? !!this.userStore.currBusiness.sub_otherpayments_id : false;
		},
		hasOrderPay() {
			return this.userStore && this.userStore.currBusiness && this.userStore.currBusiness.plan_id && this.userStore.currPlans.order_pay;
		},
		pluginsActive() {
			let plugins = [];
			for(let i in this.pluginsStore.externalPlugins) {
				let currPlugin = this.pluginsStore.externalPlugins[i];
				if(COUNTRY === 'IT' || ![1,2].includes(currPlugin.plugin_id)) {
					plugins.push({
						...currPlugin,
						active: this.activePlugin === currPlugin.plugin_id,
						title: currPlugin.name,
						selected: currPlugin.selected,
						customSlot: 'plugin-heading',
						dropdownSlot: 'plugin-dropdown',
					});
				}
			}
			plugins.push({customSlot: 'new-plugin', title: this.getString('new_plugin'), active: this.newActive});
			return plugins;
		},
		buttonsArray() {
			return [
				{
					text: this.getString('ok'),
					callback: () => {
						this.id = null;
						this.secret = null;
						this.$refs["popup-credentials"].toggleStatus(false);
					},
				},
			]
		},
		buttonsDeleteArray() {
			return [
				{
					text: this.getString('cancel'),
					negative: true,
				},
				{
					text: this.getString('delete'),
					loading: this.loadingPluginDelete,
					callback: () => {
						this.confirmDeletePlugin();
					},
				},
			]
		},
		bottomSheetWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else if (this.windowWidth < 1080) {
				return "720px";
			} else {
				return "960px";
			}
		},
		bottomSheetWideWidth() {
			if (this.windowWidth < 550) {
				return "100%";
			} else if (this.windowWidth < 768) {
				return "550px";
			} else if (this.windowWidth < 1080) {
				return "720px";
			} else if (this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
	},
	methods: {
		paymentComplete() {
			setTimeout(() => {
				this.userStore.refreshBusiness(this.userStore.currBusinessId);
			}, 2000);
			setTimeout(() => {
				this.clientSecret = null;
			}, 2500);
		},
		togglingPopupSheet(v) {
			if(!v) {
				this.clientSecret = null;
			}
		},
		subOtherPaymentsMethod() {
			this.loadingOtherPayments = true;
			this.userStore.subOtherPaymentsMethods("external-plugins-fees", (success, details) => {
				this.$refs["popup-other-payments"].toggleStatus(false);
				this.loadingOtherPayments = false;
				if(!success) {
					if(details && details === 'currency_mismatch') {
						this.showNotification("user-currency-mismatch", [this.userStore?.user?.name]);
					} else {
						this.showNotification("generic-fail");
					}
				} else {
					this.clientSecret = success;
				}
			});
		},
		readablePluginPrice(plugin) {
			let finalPrice = this.currencyStore.dbToActualValue(plugin['price_month_amount']);
			return finalPrice ? '+ '+this.currencyStore.readableCurrencyValue(finalPrice, false) : this.getString('free');
		},
		readableFixedFee(plugin) {
			if(!plugin.order_fixed_fee) {
				return '';
			}
			return this.getString('fixed_order_fee', [this.currencyStore.readableCurrencyValue(plugin.order_fixed_fee)]);
		},
		togglingPopupPlugin(status) {
			if(!status) {
				this.pluginSyncId = null;
			}
		},
		togglingPopupPluginLogs(status) {
			if(!status) {
				this.pluginLogsId = null;
			}
		},
		notifyMissingOrderPaySubscription() {
			if(!this.hasOrderPay) {
				this.showNotification('order-pay-needed');
			}
		},
		clickItem(index) {
			let currItem = this.pluginsActive[index];
			for(let i in this.pluginsActive) {
				let item = this.pluginsActive[i];
				if(item.plugin_id !== currItem.plugin_id) {
					item.active = false;
				}
			}
			if(this.newActive) {
				this.newActive = false;
			}
			currItem.active = !currItem.active;
			this.activePlugin = currItem.active ? currItem.plugin_id : null;
			if(currItem.active) {
				let scrollItem = document.querySelector('.main-content');
				if(scrollItem && this.$refs['plugin-'+index] && this.$refs['plugin-'+index].parentElement) {
					setTimeout(()=>{
						let currItem = this.$refs['plugin-'+index];
						if(currItem && currItem.parentElement) {
							let itemTop = currItem.parentElement.getBoundingClientRect().top;
                            let containerTop = scrollItem.getBoundingClientRect().top;
                            let containerScroll = scrollItem.scrollTop;
							scrollItem.scrollTo({top: itemTop - containerTop + containerScroll, behavior: 'smooth'});
						}
					}, 510);
				}
			}
		},
		toggleNewItem(force = null) {
			if(force !== null) {
				this.newActive = force;
			} else {
				this.newActive = !this.newActive;
			}
			if(this.activePlugin) {
				this.activePlugin = null;
			}
		},
		addedPlugin(id, secret) {
			this.toggleNewItem(false);
			this.pluginsStore.refreshExternalPlugins();
			this.id = id;
			this.secret = secret;
			this.$refs["popup-credentials"].toggleStatus(true);
		},
		togglePlugin(item) {
			if(item.selected) {

				this.loadingSubscription = true;
				this.pluginsStore.disablePlugin(item.plugin_id, success=>{
					this.loadingSubscription = false;
					if(success) {
						this.showNotification('generic-success');
					} else {
						this.showNotification('generic-fail');
					}
				});

			} else {
				if(!this.hasOrderPay) {
					this.notifyMissingOrderPaySubscription();
					return;
				}
				let externalLocationComponent = this.$refs['external-location-id-'+item.plugin_id];
				let externalLocationId = null;
				if(externalLocationComponent && externalLocationComponent.currentValue) {
					externalLocationId = externalLocationComponent.currentValue;
				}
				if(!externalLocationId || externalLocationId.length < 1) {
					this.showNotification('external-location-id-invalid');
					return;
				}

				let secret = null;
				let secretToken = this.$refs['plugin-secret-'+item.plugin_id];
				if(secretToken && secretToken.currentValue) {
					secret = secretToken.currentValue;
				}

				this.loadingSubscription = true;
				this.pluginsStore.enablePlugin(item.plugin_id, externalLocationId, secret, resp=>{
					this.loadingSubscription = false;
					if(resp === true) {
						this.showNotification('generic-success');
					} else if(resp === 'not_paid') {
						this.showNotification('external-plugin-not-paid');
					} else {
						this.showNotification(resp === "invalid_response" || resp === "no_response" ? 'invalid-response' : 'generic-fail');
					}
				});
			}
		},
		clickEnablePaidPlugin(item) {
			if(this.loadingPaidPlugin) { return }
			if(!this.otherPaymentsActive) {
				this.$refs["popup-other-payments"].toggleStatus(true);
				return;
			}
			this.loadingPaidPlugin = true;
			this.pluginsStore.toggleExternalPlugin(item.plugin_id, true, success=>{
				this.loadingPaidPlugin = false;
				if(success) {
					this.showNotification('generic-success');
				} else {
					this.showNotification('generic-fail');
				}
			});
		},
		disablePaidPlugin(item) {
			if(this.loadingPaidPlugin) { return }
			this.loadingPaidPlugin = true;
			this.pluginsStore.toggleExternalPlugin(item.plugin_id, false, success=>{
				this.loadingPaidPlugin = false;
				if(success) {
					this.showNotification('generic-success');
				} else {
					this.showNotification('generic-fail');
				}
			});
		},
		deletePlugin(item) {
			this.activePlugin = item.plugin_id;
			this.$refs["popup-delete-plugin"].toggleStatus(true);
		},
		confirmDeletePlugin() {
			this.loadingPluginDelete = true;
			this.pluginsStore.deletePlugin(this.activePlugin, (success) => {
				this.loadingPluginDelete = false;
				this.$refs["popup-delete-plugin"].toggleStatus(false);
				this.showNotification(success ? 'generic-success' : 'generic-fail');
			});
		},
		isPaidPlugin(plugin) {
			return !!plugin.stripe_product_id;
		},
		availablePlugin(plugin) {
			return this.isPaidPlugin(plugin) ? plugin.paid : true;
		},
	},
	mounted() {
		if(this.userStore.currBusinessId) {
			this.pluginsStore.refreshExternalPlugins();
		}
	},
	watch: {
		'userStore.currBusinessId': function () {
			this.pluginsStore.refreshExternalPlugins();
		},
	}
}
</script>

<style lang="scss" scoped>
.icon-dimension-15 {
	width: 15px;
	height: 15px;
}
.card-margin {
	margin-top: var(--main-padding);

	.blur-container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 150;
        background-color: rgba(0,0,0,0.3);
        border-radius: 0 0 13px 13px;
	}

	.plugin-heading {
		cursor: pointer;
		align-items: stretch;

		* {
			pointer-events: none;
		}

		.plugin-heading-icon {
			@include centered;
			width: 90px;
			padding: 20px 10px 20px 20px;

			.plugin-icon-container {
				@include centered;
				border-radius: 13px;
				width: 60px;
				height: 60px;
				background: transparent linear-gradient(225deg, var(--color-start) 0%, var(--color-end) 100%) 0% 0% no-repeat padding-box;
				box-shadow: 0px 3px 10px var(--color-box-shadow-3);

				div, img {
					@include centered;
					width: 30px;

					&:deep(svg) {
						width: 100%;
						height: 100%;

						.fill { fill: var(--color-bg); }
						.stroke { stroke: var(--color-bg); }
					}
				}

			}

			&.beta {

				.plugin-icon-container {
					background: transparent linear-gradient(225deg, #FFFFFF 0%, #E5EDF6 100%) 0% 0% no-repeat padding-box;

					div, img {
						&:deep(svg) {
							.fill { fill: $primary; }
							.stroke { stroke: $primary; }
						}
					}
				}
			}
		}
		.plugin-heading-text {
			@include centered;
			flex-direction: column;
			align-items: flex-start;
			width: calc(100% - 100px - 90px);
			padding: 10px;

			h3 {
				font-size: 14px;
			}
			p {
				font-size: 12px;
				line-height: 16px;
				display: flex;
				align-items: center;

				.private-tag {
					background-color: $danger;
					color: var(--color-bg);
					font-size: 10px;
					font-weight: bold;
					padding: 0 5px;
					margin-right: 5px;
					line-height: 16px;
					border-radius: 6px;
				}
			}
			.requirement-tag {
				@include centered;
				position: relative;
				margin: 5px 6px 0 0;
				padding: 5px;
				background: linear-gradient(225deg, var(--color-start) 0%, var(--color-primary) 100%) 0% 0% no-repeat;
				border-radius: 7px;

				&:deep(svg)	{
					height: 12px;
					width: 12px;
					.fill { fill: var(--color-bg); }
					.stroke { stroke: var(--color-bg); }
				}
			}
		}
		.plugin-heading-status {
			display: flex;
			flex-direction: column;
			justify-content: space-around;
			align-items: center;
			width: 100px;
			padding: 10px 20px 10px 10px;

			.price-container p {
				font-size: 14px;
			}

			.open-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;

				.plugin-status-container {
					height: 27px;
					width: 27px;
					border-radius: 50%;
					background-color: var(--color-bg);
					box-shadow: 0 1px 3px $alpha;
					position: relative;

					&, & * {
						@include noSelect();
						pointer-events: none;
					}
					&:after {
						content: "";
						position: absolute;
						display: block;
						top: 6px;
						left: 6px;
						width: 15px;
						height: 15px;
						border-radius: 50%;
						background: var(--color-bg-primary-1);
						box-shadow: inset 0 1px 1px var(--color-box-shadow-2);
					}
					&.active {
						box-shadow: 0 0 2px var(--color-box-shadow-2);
						&::after {
							background-color: var(--color-secondary);
						}
					}
				}
			}

		}

		@media (max-width: 500px) {
			.plugin-heading-icon {
				width: 60px;
				padding: 14px 8px;

				.plugin-icon-container {
					width: 44px;
					height: 44px;

					div, img {
						width: 24px;
					}
				}
			}
			.plugin-heading-text {
				padding: 10px 8px 10px 0;
				width: calc(100% - 60px - 100px);
			}
		}
	}
	.new-plugin-container {
		padding: 8px 12px;
		width: 100%;
		.row-clickable {
			cursor: pointer;
			&-new-plugin {
				background-color: var(--color-bg-primary-2);
				padding: 5px 10px;
				border-radius: 13px;
				.chevron-p {
					color: var(--color-primary);
				}
			}
			.chevron-p {
				flex-grow: 1;
			}
			.chevron-container {
				@include centered;
				justify-content: flex-end;
				width: 50px;
				height: 35px;

			}

		}

		:deep(.dropdown-container .dropdown .dropdown-content) {
			position: relative;
			margin-top: 10px;
			padding: 10px;
			border-radius: 13px;

			&:before {
				display: none;
			}
		}
	}

	.plugin-dropdown {
		justify-content: flex-end;
		align-items: flex-end;
		flex-wrap: unset;

		.dropdown-left, .dropdown-right {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			justify-content: flex-end;
		}

		.dropdown-title {
			font-size: 12px;
			font-weight: bold;
			color: var(--color-txt-2);
		}

		.logs-row-container, .sync-row-container {
			width: 100%;
		}
		
		.row-dropdown {
			max-width: 600px;
			padding-right: 12px;
			position: relative;
			gap: 8px;

			&.line {
				&:after {
					content: "";
					display: block;
					width: 100%;
					height: 1px;
					background-color: $alpha_4;
					margin: 12px 0;
				}
			}

			.input-wrapper {
				margin-left: auto;
				width: 220px;
			}
		}

		@media (max-width: 460px) {
			flex-direction: column;

			.row-dropdown {
				padding-right: 0;
			}
		}

		.dropdown-value {
			font-size: 14px;
			@include textSelect();
			text-align: right;
		}

		.dropdown-left {
			position: relative;
			align-items: flex-start;
			align-self: stretch;
			flex-grow: 1;
			padding-left: 80px;

			.icon-tick {
				width: 14px;

				&:deep(svg)	{
					width: 100%;
					height: 14px;
					fill: var(--color-primary)!important;
					stroke: var(--color-primary)!important;
				}
			}
			p {
				padding-left: 5px;
				font-size: 12px;
				line-height: 16px;
				margin-bottom: 2px;
				max-width: calc(100% - 14px);
			}
			h4 {
				color: $primary;
				font-size: 12px;
				font-style: italic;
			}

			&:after {
				@include pseudoLine(100%, 1px, 0, 100%, $alpha_4);
			}
			&.no-after {
				width: 100%;

				&:after { display: none; }
			}
		}
		.dropdown-right {
			width: 130px;

			p {	color: $primary; }
			small {
				font-size: 12px;
				line-height: 14px;
				color: $primary;
				text-align: right;

				&.fixed-order-fee {
					font-size: 10px;
					line-height: 12px;
				}
			}
		}

		@media (max-width: 1200px) {
			.dropdown-right {
				width: 100px;
				min-width: 100px;
			}
		}

		@media (max-width: 500px) {
			.dropdown-left {
				padding-left: 50px;
			}
		}

		@media (max-width: 460px) {
			.dropdown-left {
				padding: 8px;
				width: 100%;
				&:after {
					display: none;
				}
			}
			.dropdown-right {
				padding: 0 8px 8px 8px;
				width: 100%;
			}
		}
	}
	.button-row {
		flex-direction: column;
		align-items: flex-end;
		justify-content: flex-start;
		padding-top: 20px;
		gap: 8px;

		@media (max-width: 460px) {
			padding: 0 8px 8px 8px;
		}
	}

	:deep(.list-container .list-item) {
		padding: 0;
	}
	:deep(.dropdown-container .dropdown .dropdown-content) {
		position: relative;
		margin-top: 0;
		padding: 20px;
		border-radius: 0;

	}
	@media (max-width: 500px) {
		:deep(.dropdown-container .dropdown .dropdown-content) {
			padding: 8px;
		}
		.plugin-heading-status {
			padding-left: 0;
		}
	}
}
.credential-title {
	font-size: 12px;
	color: var(--color-txt-2);
	font-weight: bold;
	margin-right: 8px;
}
.credential-secret {
	font-size: 14px;
	@include textSelect();
}
</style>